import 'App.scss';
import { useEffect } from 'react';
import Popup from 'Components/Popup/Popup';
import { TAG_MANAGER_HEADER, TAG_MANAGER_BODY } from 'Constants/config';

function App() {

  useEffect(() => {
    const GTM_SCRIPT_HEAD = document.createRange().createContextualFragment(TAG_MANAGER_HEADER);
    document.head.appendChild(GTM_SCRIPT_HEAD);

    const GTM_SCRIPT_BODY = document.createRange().createContextualFragment(TAG_MANAGER_BODY);
    document.body.appendChild(GTM_SCRIPT_BODY);
  }, [])

  return (
    <div className="App" >
      <Popup />
    </div>
  );
}

export default App;
